import { getM8UserURL } from 'services/production/utils/getM8URL';
import { HTTPResponseError } from 'utils/errors';
import { customFetch } from 'utils/http';

export const getEstimatedPilotPeriodEndDate = async (): Promise<string> => {
  const response = await customFetch(
    getM8UserURL('getEstimatedPilotPeriodEndDate')
  );

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  const value = await response.text();

  return value;
};
